import type { ReactNode } from 'react';
import type { ImageProps } from 'next/image';

// Components
import FeatureDescription from '@/components/composite/FeatureDescription';

type SectionType = {
    title?: string;
    options: string[];
};

type FeatureDescriptionDefaultProps = {
    data: {
        title: string;
        description: string;
        illustration: {
            en: Pick<ImageProps, 'src'>;
            fr: Pick<ImageProps, 'src'>;
            es: Pick<ImageProps, 'src'>;
        };
        actionButton: ReactNode;
        sections: SectionType[];
    };
};

function FeatureDescriptionDefault({ data }: FeatureDescriptionDefaultProps) {
    return (
        <FeatureDescription>
            <FeatureDescription.LeftSide>
                <FeatureDescription.Title>{data.title}</FeatureDescription.Title>
                <FeatureDescription.Description>{data.description}</FeatureDescription.Description>
                {data.sections.map((section, idSection) => {
                    return (
                        <div className="mt-8" key={idSection}>
                            {section.title ? (
                                <FeatureDescription.SubTitle>
                                    {section.title}
                                </FeatureDescription.SubTitle>
                            ) : null}

                            <ul className="mt-5 space-y-5">
                                {section.options.map((option, idOption) => {
                                    return (
                                        <li key={idOption}>
                                            <FeatureDescription.Option>
                                                {option}
                                            </FeatureDescription.Option>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    );
                })}
            </FeatureDescription.LeftSide>
            <FeatureDescription.RightSide>
                <FeatureDescription.Illustration illustration={data.illustration} />
                <div className="mt-8 flex justify-center">{data.actionButton}</div>
            </FeatureDescription.RightSide>
        </FeatureDescription>
    );
}

export default FeatureDescriptionDefault;
